module.exports = ".login-page {\n    overflow: hidden;\n    min-height: 85%;\n    \n  }\n\n  b{\n      font-size:2em;\n  }"